import React from "react";
import PropTypes from "prop-types";

import { UIProgressBar } from "../../ui";
import "./NationalityMix.scss";

/**
 * Saudi / Non-Saudi split for an event's applicants — a two-tone bar with a
 * legend. `saudiPercent` drives the bar.
 */
const NationalityMix = ({
  label,
  applicantsLabel,
  count,
  saudiLabel,
  nonSaudiLabel,
  saudiPercent,
  nonSaudiPercent,
}) => {
  // Shown exactly as the API returns them; `null` (no applicants) → 0.
  const formatPercent = (value) => `${value ?? 0}%`;
  const barValue = Math.max(0, Math.min(100, saudiPercent ?? 0));

  return (
    <div className="nationality-mix">
      <div className="nationality-mix__row">
        <span className="nationality-mix__label">{label}</span>
        <span className="nationality-mix__label">
          {applicantsLabel.replace("{count}", count)}
        </span>
      </div>

      <UIProgressBar
        value={barValue}
        barColor="var(--color-success-default)"
        trackColor="var(--color-primary-200, #C4B5FD)"
        className="nationality-mix__bar"
      />

      <div className="nationality-mix__row">
        <span className="nationality-mix__legend">
          <span className="nationality-mix__dot nationality-mix__dot--saudi" />
          {saudiLabel} {formatPercent(saudiPercent)}
        </span>
        <span className="nationality-mix__legend">
          <span className="nationality-mix__dot nationality-mix__dot--non-saudi" />
          {nonSaudiLabel} {formatPercent(nonSaudiPercent)}
        </span>
      </div>
    </div>
  );
};

NationalityMix.propTypes = {
  label: PropTypes.string.isRequired,
  applicantsLabel: PropTypes.string.isRequired,
  count: PropTypes.number,
  saudiLabel: PropTypes.string.isRequired,
  nonSaudiLabel: PropTypes.string.isRequired,
  saudiPercent: PropTypes.number,
  nonSaudiPercent: PropTypes.number,
};

NationalityMix.defaultProps = {
  count: 0,
  saudiPercent: null,
  nonSaudiPercent: null,
};

export default NationalityMix;
